'use client';

import React__default, { useRef, useEffect } from 'react';
import Init from './core/init.js';
import { Container } from './Chart.css.js';
import '../_virtual/_tslib.js';
import Legend from './core/modules/legend.rc.js';

var Chart = function (_a) {
    var config = _a.config;
    var canvasRef = useRef(null);
    var containerRef = useRef(null);
    var _b = (config.chart.legend || {}).enable, enable = _b === void 0 ? true : _b;
    useEffect(function () {
        if (canvasRef && canvasRef.current && containerRef && containerRef.current) {
            var container = containerRef.current;
            var canvas = canvasRef.current;
            var init_1 = Init(canvas, container, config);
            document.fonts.ready.then(function () { return init_1.run(); });
            return function () {
                init_1.destroy();
            };
        }
        else {
            return function () { };
        }
    }, [config]);
    return (React__default.createElement(Container, { className: 'vnw-chart-container', ref: containerRef },
        React__default.createElement("canvas", { id: 'vnw-chart', ref: canvasRef }),
        enable ? React__default.createElement(Legend, { config: config }) : null));
};

export { Chart as default };
//# sourceMappingURL=index.js.map
